import { render, staticRenderFns } from "./volunteerAvailableRoles.vue?vue&type=template&id=5af2c235&scoped=true"
import script from "./volunteerAvailableRoles.vue?vue&type=script&lang=js"
export * from "./volunteerAvailableRoles.vue?vue&type=script&lang=js"
import style0 from "./volunteerAvailableRoles.vue?vue&type=style&index=0&id=5af2c235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af2c235",
  null
  
)

export default component.exports